import log from './utils/logger.js'

const GGS_BACKFILL_ORDER_IDS = [2866122916]

let cxf

const TED = 1167 // Tracking-Event Definitions
const CXF_TRACK_MSG = 'cxf.tracking.message'

const BANNER_ACTIVE = `banner_active`
const BANNER_INACTIVE = `banner_inactive`
const BANNER_CLICKED = `banner_clicked`
const BANNER_REFRESHED = `banner_refreshed`

const ACTION_TO_ID_MAP = new Map([
    [BANNER_ACTIVE, 7],
    [BANNER_INACTIVE, 8],
    [BANNER_CLICKED, 9],
    [BANNER_REFRESHED, 10]
])

const GGS_BACKFILL = `ggs_backfill`

const init = (cxfInst) => {
    log.debug('tracking has been initialized', cxfInst)
    cxf = cxfInst
}

const tracking = (actionType, parameters) => {
    let payload = {
        eventId: TED,
        gameId: Number.parseInt(cxf.gameId, 10),
        networkId: Number.parseInt(cxf.networkId, 10),
        instanceId: cxf.instanceId,
        playerId: cxf.playerId,
        language: cxf.countryCode,
        timestamp: new Date().toUTCString(),
        zoneId: cxf.zoneId,
        actionType: ACTION_TO_ID_MAP.get(actionType) || -5 // -5 is id for not registered action type
    }

    payload = {...payload, ...parameters}

    log.debug(CXF_TRACK_MSG, JSON.stringify(payload, null, 4))
    cxf.emit(CXF_TRACK_MSG, payload)
}

const getBannerRefreshTrackedParameters = (gptEvent) => {
    const result = {}

    if (
        gptEvent.campaignId &&
        GGS_BACKFILL_ORDER_IDS.includes(gptEvent.campaignId)
    ) {
        // eslint-disable-next-line camelcase
        result.impression_id = GGS_BACKFILL
    }

    return result
}

export {
    BANNER_ACTIVE,
    BANNER_INACTIVE,
    BANNER_CLICKED,
    BANNER_REFRESHED,
    getBannerRefreshTrackedParameters,
    init,
    tracking
}

export const __internal = {
    GGS_BACKFILL_ORDER_IDS,
    GGS_BACKFILL,
    ACTION_TO_ID_MAP
}
